import { useEffect } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import { HTML_COMPONENT_NAME } from 'hb-builder/constants/HtmlComponentName';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import { getContent } from 'hb-builder/utils/item';

const componentType = 'single';

const Html: RenderComponent = () => <div />; // never used

const Render = ({ children }) => {
  const content = getContent(children);
  const { isMobilePreview } = useRendererContext();

  useEffect(() => {
    const getScripts = (startIndex = 0) => {
      const start = content.indexOf('<script', startIndex);

      if (start > -1) {
        const end = content.indexOf('</script>', start) + '</script>'.length;
        const script = content.substr(start, end - start);
        const rawScript = /<script>([\s\S]*?)<\/script>/.exec(script)?.[1];

        if (!rawScript) return;

        // TODO: Improve this part
        let executeScript;

        try {
          // eslint-disable-next-line no-new-func
          executeScript = new Function(rawScript);
          // eslint-disable-next-line no-empty
        } catch {}

        executeScript?.();

        if (end <= content.length - 1) {
          getScripts(end);
        }
      }
    };

    getScripts();
  }, [content]);

  return (
    // @ts-expect-error untyped
    <Wrapper
      attributes={{}}
      className=""
      componentType={componentType}
      dataTestId="builder-component-html"
      id=""
      isMobilePreview={isMobilePreview}
      style={{}}
    >
      <StyledWrapper>
        <WrapperHtml dangerouslySetInnerHTML={{ __html: content }} />
      </StyledWrapper>
    </Wrapper>
  );
};

Html.componentName = HTML_COMPONENT_NAME;
Html.Render = Render;

export default Html;

const WrapperHtml = styled.div`
  width: 100%;

  p {
    margin: unset;
  }
`;

const StyledWrapper = styled(Box)`
  flex: 1;
  line-height: 1.6;
  white-space: break-spaces;
  word-break: break-word;
`;
